import type { ReactNode } from 'react';

export const symbol_android_cell_4_bar_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M602.88-160q-20.88 0-35.38-14.58Q553-189.17 553-210v-110L407-423v213q0 20.83-14.62 35.42Q377.76-160 356.88-160q-20.88 0-35.38-14.58Q307-189.17 307-210v-283L69-659q-14-10-17-25.5t7-29.5q10-14 26-17t30 7l721 504q14 10 16.5 25.5T845-165q-10 14-25.5 17t-29.5-7l-137-95v40q0 20.83-14.62 35.42Q623.76-160 602.88-160ZM900-248l-100-70v-431q0-20.83 14.62-35.42Q829.24-799 850.12-799q20.88 0 35.38 14.58Q900-769.83 900-749v501ZM60-210v-208q0-20.83 14.62-35.42Q89.24-468 110.12-468q20.88 0 35.38 14.58Q160-438.83 160-418v208q0 20.83-14.62 35.42Q130.76-160 109.88-160 89-160 74.5-174.58 60-189.17 60-210Zm593-211-100-70v-134q0-20.83 14.62-35.42Q582.24-675 603.12-675q20.88 0 35.38 14.58Q653-645.83 653-625v204Z"
		/>
	</svg>
);
